module.exports = __webpack_public_path__ + "static/media/VidhyaOnlinenew.fc0f251c.png";